export const CUSTOMER_TITLES = ['Mr', 'Mrs', 'Ms', 'Miss', 'Mx', 'Dr']
export enum CONSUMER_TYPE {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS',
}
export const CONSUMER_TYPES = [{ value: CONSUMER_TYPE.PERSONAL, label: 'Personal' }, { value: CONSUMER_TYPE.BUSINESS, label: 'Business' }]
